import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PipesModule } from 'app/shared/pipes/pipes.module';
import { FilterTextComponent } from './filter-text.component';

@NgModule({
  imports: [CommonModule, PipesModule],
  declarations: [FilterTextComponent],
  exports: [FilterTextComponent],
})
export class FilterTextModule {}
